function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M42.005 63.825h-14.14c-.75 0-1.36-.61-1.36-1.36 0-.75.61-1.36 1.36-1.36h14.14c13.22.04 23.98-10.64 24.02-23.86.04-13.22-10.64-23.98-23.86-24.02h-17.16c-.75 0-1.36-.61-1.36-1.36v-7.21l-19.59 15.31 10.2 7.97 9.39 7.33v-7.2c0-.75.61-1.36 1.36-1.36h17c5.77-.03 10.47 4.62 10.5 10.39.03 5.77-4.62 10.47-10.39 10.5h-14.25c-.75 0-1.36-.61-1.36-1.36 0-.75.61-1.36 1.36-1.36h14.14c4.27.03 7.76-3.42 7.78-7.69a7.731 7.731 0 00-7.69-7.78h-15.74v8.62c0 .75-.61 1.35-1.36 1.35-.3 0-.6-.1-.83-.29l-11.58-9.04-11.57-9.04a1.352 1.352 0 010-2.13L24.155.785c.59-.46 1.44-.36 1.9.23.19.24.29.53.29.83v8.63h15.65c14.72-.05 26.69 11.85 26.74 26.57.05 14.72-11.85 26.69-26.57 26.74h-.17v0z",
  strokeMiterlimit: 10
});

function SvgReturn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 69.235 64.325",
    xmlns: "http://www.w3.org/2000/svg",
    className: "w-full h-full fill-current"
  }, props), _ref);
}

export default SvgReturn;